import { Card, Toast, Icons } from "@pushpress/shared-components";

export default function InfoCard() {
  return (
    <Card>
      <Toast
        icon={Icons.Warning}
        iconColor="success"
        message="This plan won't be charged a payment because it was previously paid
        for in your old software."
      />
    </Card>
  );
}
